import React, { ReactNode } from 'react';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import theme from 'src/theme/light';
import { ChangeStateDesconto } from 'src/components/projetos/historico/Historico';
import { Formater, TypeRecords } from 'src/framework/commons/Formater';

interface ComparisonTableProps {
  dados: any[];
  changeState: ChangeStateDesconto;
}

const styles = makeStyles({
  titulo: {
      fontWeight: "bold",
      border: '1px solid grey'
  },
  alterado: {
      backgroundColor: "#BBE6C9",
      border: '1px solid grey'
  },
  removido: {
      backgroundColor: theme.palette.error.light,
  },
  adicionado: {
      backgroundColor: theme.palette.primary.light,
  },
  header: {
      backgroundColor: theme.palette.primary.main,
      color: theme.palette.primary.contrastText,
      fontWeight: "bold",
  },
  historico_selecionado: {
      backgroundColor: theme.palette.grey[200],
      border: '1px solid grey'
  },
  icon_alterou : {
      color: theme.palette.warning.main,
      fontSize: "14px"
  },
});

const TabelaComparacaoDescontos: React.FC<ComparisonTableProps> = (props) => {
  const classes = styles();
  const maskDate = (date: string | Date, datetime: boolean)=>{
    if(date){
        const data = new Date(date);

        if (datetime){
            const formattedData = data.toLocaleString('pt-BR', {
                day: 'numeric',
                month: 'numeric',
                year: 'numeric',
                hour: 'numeric',
                minute: 'numeric',
                second: 'numeric',
            });
            return formattedData;
        }else{
            const formattedData = data.toLocaleString('pt-BR', {
                day: 'numeric',
                month: 'numeric',
                year: 'numeric',
            });
            return formattedData;
        }    
    }else return "-";
}
  const compareRow = ((campo: string, descontos: any, changed: boolean): ReactNode =>{
    switch(campo){
      case "usuario":
        return(<>
          {descontos.map((_historico: any)=>{
            return(<TableCell className={changed ? classes.alterado : classes.historico_selecionado}>{_historico?.usuario || "-"}</TableCell>)
          })}
        </>);
      case "justificativa":
        return(<>
          {descontos.map((_historico: any)=>{
            return(<TableCell className={changed ? classes.alterado : classes.historico_selecionado}>{_historico?.justificativa || "-"}</TableCell>)
          })}
        </>);
      case "valor_intelbras":
        return(<>
          {descontos.map((_historico: any)=>{
            return(<TableCell className={changed ? classes.alterado : classes.historico_selecionado}>{_historico?.valor_intelbras ? Formater.toString(_historico?.valor_intelbras, TypeRecords.CURRENCY) : "-"}</TableCell>)
          })}
        </>);
      case "percentual_intelbras":
        return(<>
          {descontos.map((_historico: any)=>{
            return(<TableCell className={changed ? classes.alterado : classes.historico_selecionado}>{_historico?.percentual_intelbras ? Formater.toString(_historico?.percentual_intelbras, TypeRecords.DECIMAL2) + "%" : "-"}</TableCell>)
          })}
        </>);
      case "percentual_distribuidor":
        return(<>
          {descontos.map((_historico: any)=>{
            return(<TableCell className={changed ? classes.alterado : classes.historico_selecionado}>{_historico?.percentual_distribuidor ? Formater.toString(_historico?.percentual_distribuidor, TypeRecords.DECIMAL2) + "%" : "-"}</TableCell>)
          })}
        </>);
      case "percentual_revenda":
        return(<>
          {descontos.map((_historico: any)=>{
            return(<TableCell className={changed ? classes.alterado : classes.historico_selecionado}>{_historico?.percentual_revenda ? Formater.toString(_historico?.percentual_revenda, TypeRecords.DECIMAL2) + "%" : "-"}</TableCell>)
          })}
        </>);
      case "desconto_total":
        return(<>
          {descontos.map((_historico: any)=>{
            return(<TableCell className={changed ? classes.alterado : classes.historico_selecionado}>{_historico?.desconto_total ? Formater.toString(_historico?.desconto_total, TypeRecords.DECIMAL2) + "%" : "-"}</TableCell>)
          })}
        </>);
      default:
        return(<>
        {descontos.map((_historico: any)=>{
          return(
            <TableCell className={changed ? classes.alterado : classes.historico_selecionado}>{"-"}</TableCell>
          )
        })}</>)
    }})
  return (<>
    <TableContainer className='table-historico' sx={{ overflowX: "auto" }}>
        <Table size="small">
            <TableHead>
                <TableRow>
                    <TableCell></TableCell>
                    {props.dados.map(_historico=>{
                      return(
                        <TableCell 
                          key={_historico.id}
                          style={{fontWeight: "bold"}}
                        >
                          Desconto em: {maskDate(_historico?.created_at || "", true)}
                        </TableCell>
                      )
                    })}                    
                </TableRow>
            </TableHead>
            <TableBody>
                <TableRow>
                    <TableCell className={classes.header} colSpan={props?.dados?.length+1 || 1}>Descontos</TableCell>
                </TableRow>
                <TableRow className={`row ${props?.changeState?.usuario?.hasChanged ? classes.alterado : ""}`}>
                    <TableCell className={classes.titulo}>Usuário</TableCell>
                    {compareRow("usuario", props.dados, props?.changeState?.usuario?.hasChanged)}
                </TableRow>
                <TableRow className={`row ${props?.changeState?.justificativa?.hasChanged ? classes.alterado : ""}`}>
                    <TableCell className={classes.titulo}>Justificativa</TableCell>
                    {compareRow("justificativa", props.dados, props?.changeState?.justificativa?.hasChanged)}
                </TableRow>
                <TableRow className={`row ${props?.changeState?.valor_intelbras?.hasChanged ? classes.alterado : ""}`}>
                    <TableCell className={classes.titulo}>Valor Desconto Intelbras</TableCell>
                    {compareRow("valor_intelbras", props.dados, props?.changeState?.valor_intelbras?.hasChanged)}
                </TableRow>
                <TableRow className={`row ${props?.changeState?.percentual_intelbras?.hasChanged ? classes.alterado : ""}`}>
                    <TableCell className={classes.titulo}>Desconto Intelbras</TableCell>
                    {compareRow("percentual_intelbras", props.dados, props?.changeState?.percentual_intelbras?.hasChanged)}
                </TableRow>
                <TableRow className={`row ${props?.changeState?.percentual_distribuidor?.hasChanged ? classes.alterado : ""}`}>
                    <TableCell className={classes.titulo}>Desconto Distribuidor</TableCell>
                    {compareRow("percentual_distribuidor", props.dados, props?.changeState?.percentual_distribuidor?.hasChanged)}
                </TableRow>
                <TableRow className={`row ${props?.changeState?.percentual_revenda?.hasChanged ? classes.alterado : ""}`}>
                    <TableCell className={classes.titulo}>Desconto Revenda</TableCell>
                    {compareRow("percentual_revenda", props.dados, props?.changeState?.percentual_revenda?.hasChanged)}
                </TableRow>
                <TableRow className={`row ${props?.changeState?.desconto_total?.hasChanged ? classes.alterado : ""}`}>
                    <TableCell className={classes.titulo}>Desconto Total</TableCell>
                    {compareRow("desconto_total", props.dados, props?.changeState?.desconto_total?.hasChanged)}
                </TableRow>
            </TableBody>            
        </Table>
    </TableContainer>
  </>);
};

export default TabelaComparacaoDescontos;
